import * as core from '../../../core';
import { inferParsedObject } from '../../../core/schemas';
import { CredentialDocument } from '../document';
import type { CredentialBlob, Json } from '../types';

export const jsonldVocabSchema = core.serialization.undiscriminatedUnion([
    core.serialization.string(),
    core.serialization.object({}),
]);

export const jsonldContextSchema = core.serialization.undiscriminatedUnion([
    jsonldVocabSchema,
    core.serialization.list(jsonldVocabSchema),
]);

export const credentialSchemaSchema = core.serialization.object({
    id: core.serialization.string(),
    type: core.serialization.undiscriminatedUnion([
        core.serialization.string(),
        core.serialization.list(core.serialization.string()),
    ]),
});

export const vcdmProofSchema = core.serialization.object({
    type: core.serialization.string(),
});

export const vcdmProofSetSchema = core.serialization.undiscriminatedUnion([
    vcdmProofSchema,
    core.serialization.list(vcdmProofSchema),
]);

export const jsonSchemaCredentialSubjectSchema = core.serialization.object({
    id: core.serialization.string(),
    type: core.serialization.stringLiteral('JsonSchema'),
    jsonSchema: core.serialization.object({
        $schema: core.serialization.stringLiteral('https://json-schema.org/draft/2020-12/schema'),
    }),
});

export const vcdmDocumentSchema = core.serialization.object({
    '@context': jsonldContextSchema,
    type: core.serialization.list(core.serialization.string()),
    credentialSubject: core.serialization.object({
        id: core.serialization.string().optional(),
        type: core.serialization.string().optional(),
    }),
    credentialSchema: credentialSchemaSchema.optional(),
});

export type VcdmDocument = inferParsedObject<typeof vcdmDocumentSchema>;

export class VcdmCredentialDocument extends CredentialDocument {
    protected jsonToVcdm(input: Json): VcdmDocument {
        return this.parseJson(vcdmDocumentSchema, input);
    }

    protected async blobToVcdm(input: CredentialBlob): Promise<VcdmDocument> {
        return this.parseBlob(vcdmDocumentSchema, input);
    }
}
